
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { AuthApi } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import Store from "../../store";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
type FormValues = {
  username: string;
  oldpassword: string;
  newpassword: string;
  currentUsername: string;
};
@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class ChangePassword extends FormMixin {
  globalErrors: { message: string }[] = [];
  formValues: FormValues = {
    username: "",
    oldpassword: "",
    newpassword: "",
    currentUsername: ""
  };
  @Prop({ type: Object }) values: { username: string; oldpassword: string } = {
    username: "",
    oldpassword: ""
  };
  inputLock = true;
  beforeMount() {
    if (this.values) {
      this.formValues = Object.assign({ newpassword: "", currentUsername: "" }, this.values);
    }
    const auth = Store.getInstance().getAuth();
    if (auth && auth.user) {
      this.formValues.username = auth!.user.username;
    }
  }
  async onBeforeSubmit(values: FormValues) {
    await this.onSubmit(async () => {
      const auth = Store.getInstance().getAuth();
      if (auth && auth.user) {
        values["currentUsername"] = auth!.user.username;
      }
      await new AuthApi().changePassword({ changePasswordRequest: values });
      this.$emit("submitted", {
        username: values.username,
        password: values.newpassword
      });
    });
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" })),
      oldpassword: yup.string().required(this.$t("input_required", { field: "現在のパスワード" })),
      newpassword: yup.string().required(this.$t("input_required", { field: "新しいパスワード" }))
    });
  }
}
